export const numbersPerMonth = [
	{
		id: 1,
		month: 'November',
		production: 199840,
	},
	{
		id: 2,
		month: 'December',
		production: 476719,
	},
	{
		id: 3,
		month: 'January',
		production: 1010099,
	},
	{
		id: 4,
		month: 'February',
		production: 1354835,
	},
	{
		id: 5,
		month: 'March',
		production: 1851488,
	},
	{
		id: 6,
		month: 'April',
		production: 2147213,
	},
	{
		id: 7,
		month: 'May',
		production: 2552646,
	},
	{
		id: 8,
		month: 'June',
		production: 2571464,
	},
];

const baseURL = 'https://res.cloudinary.com/dpabcunnn/image/upload'

export const productionNumbers = [
	{
		type: 'Non-medical face masks',
		total: 1500000,
		image: baseURL + '/v1627826582/ppe/masks_s3sczv.jpg'
	},
	{
		type: 'Scrubs',
		total: 110000,
		image: baseURL + '/v1627826584/ppe/scrubs_zumqib.jpg'
	},
	{
		type: 'Shoe covers',
		total: 150000,
		image: baseURL + '/v1627826581/ppe/shoe-covers_m4cnts.jpg'
	},
	{
		type: 'Gowns',
		total: 140000,
		image: baseURL + '/v1627826580/ppe/gowns_cqtlje.jpg'
	},
	{
		type: 'Head covers',
		total: 400000,
		image: baseURL + '/v1627826584/ppe/scrubs_zumqib.jpg'
	},
	{
		type: 'Face shields',
		total: 275000,
		image: baseURL + '/v1627826580/ppe/faceshields_omrnhl.jpg'
	},
];
